import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const CvTemplates = createSvgIcon(React.createElement("g", { transform: "translate(2 -3.675)" },
    React.createElement("g", { transform: "translate(0 5.675)" },
        React.createElement("path", { d: "M8.873,17.788H-1.266V2.212H8.873V17.788z M0.987,15.535H6.62V4.465H0.987V15.535z" })),
    React.createElement("g", { transform: "translate(11 5.675)" },
        React.createElement("path", { d: "M10.266,17.788H0.127V2.212h10.139V17.788z M2.38,15.535h5.633V4.465H2.38V15.535z" }))), 'CvTemplates');
export default CvTemplates;
